<template>
  <div class="container">
    <h1 class="title">Bestellungen</h1>
    <h2 class="subtitle">
      Übersicht über <strong>{{ orderType }}</strong> Bestellungen
      <small v-if="this.metrics.articleQuantityTotal"
        >| {{ this.metrics.articleQuantityTotal.value }} Artikel | €
        {{ this.metrics.grossTotal.value }}
      </small>
    </h2>
    <div class="columns is-multiline">
      <div class="column is-6">
        <div class="columns is-multiline">
          <div class="column is-12">
            <b-radio
              v-model="orderType"
              @input="refreshData"
              name="ot"
              native-value="abgeschlossene"
            >
              abgeschlossene
            </b-radio>
            <b-radio
              v-model="orderType"
              @input="refreshData"
              name="ot"
              native-value="stornierte"
            >
              stornierte
            </b-radio>
          </div>
          <div class="column">
            <b-field label="Von">
              <b-datepicker
                :show-week-number="true"
                placeholder="Bitte wählen"
                icon="calendar"
                v-model="from"
                trap-focus
                @input="refreshData"
              >
              </b-datepicker>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Bis">
              <b-datepicker
                :show-week-number="true"
                placeholder="Bitte wählen."
                icon="calendar"
                v-model="to"
                trap-focus
                @input="refreshData"
              >
              </b-datepicker>
            </b-field>
          </div>
        </div>
      </div>
      <div class="column is-6 has-text-right">
        <b-button type="is-primary" @click="exportCsv">CSV Export</b-button>
      </div>
      <div class="column is-12">
        <b-field>
          <b-input
            placeholder="Suche..."
            icon="search"
            v-model="freetext"
            @keyup.enter.native="refreshData"
          >
          </b-input>
        </b-field>
      </div>
    </div>
    <p class="mx-2" v-if="this.metrics.articleQuantity && this.metrics.gross">
      <strong>{{ this.total }}</strong> Bestellungen mit insgesamt
      <strong>{{ this.metrics.articleQuantity.value }}</strong> Artikeln zu
      einem Gesamtpreis von <strong>€ {{ this.metrics.gross.value }}</strong
      >.
    </p>
    <OrdersTable
      :results="orders"
      @request-page="pageChange"
      :pageSize="pageSize"
      :page="page"
      :total="total"
    />
  </div>
</template>
<script>
import OrdersTable from '@/components/orders/OrdersTable'
import ordersApi from '@/api/orders-api'
export default {
  name: 'Orders',
  components: {OrdersTable},
  data() {
    return {
      orders: [],
      page: 1,
      pageSize: 16,
      total: 0,
      orderType: 'abgeschlossene',
      freetext: '',
      from: null,
      to: null,
      metrics: {
        articleQuantity: null,
        articleQuantityTotal: null,
        gross: null,
        grossTotal: null,
      },
    }
  },
  async mounted() {
    await this.refreshData()
  },
  methods: {
    async refreshData() {
      this.metrics = {
        articleQuantity: null,
        articleQuantityTotal: null,
        gross: null,
        grossTotal: null,
      }
      if (this.orderType == 'stornierte') {
        const result = await ordersApi.getCancelledOrders(
          this.page,
          this.pageSize,
          'default',
          this.freetext,
          this.from,
          this.to,
        )
        this.orders = result.results
        this.page = result.page
        this.pageSize = result.pageSize
        this.total = result.total
        this.metrics.articleQuantity = result.aggregation.metrics.find(
          f => f.name == 'ArticleQuantity',
        )
        this.metrics.articleQuantityTotal = result.aggregation.metrics.find(
          f => f.name == 'ArticleQuantityTotal',
        )
        this.metrics.gross = result.aggregation.metrics.find(
          f => f.name == 'Gross',
        )
        this.metrics.grossTotal = result.aggregation.metrics.find(
          f => f.name == 'GrossTotal',
        )
      } else {
        const result = await ordersApi.getClosedOrders(
          this.page,
          this.pageSize,
          'default',
          this.freetext,
          this.from,
          this.to,
        )
        this.orders = result.results
        this.page = result.page
        this.pageSize = result.pageSize
        this.total = result.total
        this.metrics.articleQuantity = result.aggregation.metrics.find(
          f => f.name == 'ArticleQuantity',
        )
        this.metrics.articleQuantityTotal = result.aggregation.metrics.find(
          f => f.name == 'ArticleQuantityTotal',
        )
        this.metrics.gross = result.aggregation.metrics.find(
          f => f.name == 'Gross',
        )
        this.metrics.grossTotal = result.aggregation.metrics.find(
          f => f.name == 'GrossTotal',
        )
      }
    },
    async pageChange(page) {
      this.page = page
      await this.refreshData()
    },
    async exportCsv() {
      if (this.orderType == 'stornierte') {
        await ordersApi.getCancelledOrdersAsCsv(this.total, 'default')
      } else {
        await ordersApi.getClosedOrdersAsCsv(this.total, 'default')
      }
    },
  },
}
</script>
